const elementIcons = [
  'AddLocation',
  'Aim',
  'AlarmClock',
  'Apple',
  'Baseball',
  'Basketball',
  'Bell',
  'Bicycle',
  'Bowl',
  'Brush',
  'Burger',
  'Calendar',
  'Camera',
  'Cellphone',
  'ChatDotRound',
  'ChatDotSquare',
  'ChatLineRound',
  'ChatLineSquare',
  'ChatRound',
  'ChatSquare',
  'Cherry',
  'CircleCheck',
  'CircleClose',
  'CirclePlus',
  'Clock',
  'Cloudy',
  'CoffeeCup',
  'Coffee',
  'Coin',
  'ColdDrink',
  'CollectionTag',
  'Collection',
  'Compass',
  'Connection',
  'Coordinate',
  'CopyDocument',
  'Cpu',
  'CreditCard',
  'Crop',
  'DataAnalysis',
  'DataBoard',
  'DataLine',
  'DeleteLocation',
  'Delete',
  'Dessert',
  'Discount',
  'DishDot',
  'DocumentAdd',
  'DocumentChecked',
  'DocumentCopy',
  'DocumentDelete',
  'DocumentRemove',
  'Document',
  'Drizzling',
  'EditPen',
  'Edit',
  'Female',
  'Files',
  'Film',
  'Filter',
  'Finished',
  'FirstAidKit',
  'FolderAdd',
  'FolderChecked',
  'FolderDelete',
  'FolderOpened',
  'FolderRemove',
  'Folder',
  'Football',
  'ForkSpoon',
  'Fries',
  'FullScreen',
  'GobletFull',
  'Goods',
  'Guide',
  'Headset',
  'Help',
  'HotWater',
  'House',
  'IceDrink',
  'IceCream',
  'IceTea',
  'Iphone',
  'Key',
  'Link',
  'Loading',
  'LocationInformation',
  'Location',
  'Lock',
  'MagicStick',
  'Male',
  'Magnet',
  'MapLocation',
  'Medal',
  'MessageBox',
  'Message',
  'Microphone',
  'MilkTea',
  'Money',
  'Monitor',
  'MoonNight',
  'MostlyCloudy',
  'Mouse',
  'Mug',
  'MuteNotification',
  'Mute',
  'NoSmoking',
  'Notebook',
  'Notification',
  'Odometer',
  'OfficeBuilding',
  'Open',
  'Operation',
  'Orange',
  'Paperclip',
  'PartlyCloudy',
  'Phone',
  'PictureRounded',
  'Picture',
  'PieChart',
  'Place',
  'Pointer',
  'Position',
  'Postcard',
  'Present',
  'PriceTag',
  'Printer',
  'Rank',
  'ReadingLamp',
  'Reading',
  'Refrigerator',
  'ScaleToOriginal',
  'School',
  'Scissor',
  'Search',
  'Sell',
  'Service',
  'SetUp',
  'Setting',
  'ShoppingBag',
  'ShoppingCartFull',
  'ShoppingCart',
  'Star',
  'SwitchButton',
  'Stopwatch',
  'Suitcase',
  'Switch',
  'TakeawayBox',
  'Tickets',
  'Timer',
  'Trophy',
  'TurnOff',
  'Umbrella',
  'Unlock',
  'User',
  'Van',
  'VideoCamera',
  'VideoPlay',
  'View',
  'Wallet',
  'Warning',
  'WindPower',
  'Box'
]
export default elementIcons
